import React, { PureComponent } from 'react'
import Head from "next/head";
import NProgress from "components/NProgress";
import SeoMeta from '/components/seoMeta';

export default class SubscribeNoti extends PureComponent {
    render() {
        return (
            <div>
              <Head>
                <title>Subscribe Us</title>
              </Head>
              <SeoMeta 
                  url={`${process.env.BACKEND_URL}/subscribe-noti`} 
                  type="article"
                  title='Subscribe to notification'
                  description="Subscribe to push notification from Duwun Media"
                  image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
                  section='Subscribe-noti'
                  keywords='Subscribe-noti'
                />        
              <NProgress />
            </div>
          );
    }
}
